import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import Button from '@mui/material/Button';

import AddchartIcon from '@mui/icons-material/Addchart';
import AddIcon from '@mui/icons-material/Add';

import SubscriptionBanner from './SubscriptionBanner';
import Early409AModal from '../../../components/Modals/Early409AModal';
// TEMP: commented with Initio transition notice
// import PlatformTransitionCard from '../../../components/PlatformTransitionCard/PlatformTransitionCard';

import { UserDataContext } from '../../../contexts';

import useFetch from '../../../hooks/useFetch';
// TEMP: getTenantFromUrl unused while isInitioTenant forced false for local testing
// import { getTenantFromUrl } from '../../../utils/tenant';

import './HomepageHeader.scss';

export default function HomepageHeader() {
  const { userData } = useContext(UserDataContext);
  // TEMP: allow Initio users to start 409A while testing locally
  // const isInitioTenant = getTenantFromUrl() === 'initio';
  const isInitioTenant = false;

  const [showEarly409AModal, setShowEarly409AModal] = useState(false);

  const [, startNew409ARequest] = useFetch();

  const nav = useNavigate();

  function timeOfDayGreeting() {
    const currentHour = moment().hour();

    if (currentHour > 16) return "evening";
    if (currentHour > 12) return "afternoon";
    return "morning";
  }

  return (
    <>
      <div className={`homepage-header${isInitioTenant ? ' homepage-header--with-notice' : ''}`}>

        <h4>
          {`Good ${timeOfDayGreeting()}, `}
          <span className="user-name">
            {`${userData.userAttributes.firstName || ''} ${userData.userAttributes.lastName || ''}`}
          </span>
        </h4>

        {!isInitioTenant && userData.userState === 'report-ready' && (
          <Button
            className="nth-transaction-btn"
            onClick={() => {
              if (moment(userData.mostRecentValuationDate, 'YYYY-MM-DD').isAfter(moment().subtract(1, 'years'))) {
                setShowEarly409AModal(true);
                return;
              }
              startNew409ARequest({
                url: '/transactions/new-transaction',
                method: 'post',
                urlIds: ['companyId'],
                onSuccess: () => nav('/409a-info?newTransaction=true'),
              });
            }}
          >
            <AddchartIcon />
            Start new 409A
          </Button>
        )}
        {!isInitioTenant && (userData.userState === '409a-not-started' || userData.userState === '409a-in-progress') && (
          <Button
            className="new-first-transaction-btn"
            onClick={() => nav('/409a-info')}
          >
            {userData.userState === '409a-not-started' && <AddIcon />}
            {userData.userState === '409a-in-progress' ? 'Resume 409A valuation' : 'Start a new 409A'}
          </Button>
        )}
        {isInitioTenant && userData.userState === '409a-in-progress' && (
          <Button
            className="new-first-transaction-btn"
            onClick={() => nav('/409a-info')}
          >
            Resume 409A valuation
          </Button>
        )}

      </div>

      {/* TEMP: commented so we can create/test a new Initio user */}
      {/* {isInitioTenant && <PlatformTransitionCard />} */}

      {/* <SubscriptionBanner /> */}
      <Early409AModal showEarly409AModal={showEarly409AModal} setShowEarly409AModal={setShowEarly409AModal} />
    </>
  );
}
